module.exports = __webpack_public_path__ + "img/comment-complete.b08c803b.png";